import clsx from "clsx";
import { useState } from "react";
import Container from "./Container";
import { Heading } from "./text";
import { ReactComponent as HIPAALogo } from "../media/compliance/hipaa_white.svg";

type SectionProps = {
  className?: string;
};

const ORANGE_HEX = "#FF8000";

const PerformanceSecuritySafety = ({ className }: SectionProps) => {
  const [hipaaHover, setHipaaHover] = useState(false);
  const blocks = [
    {
      title: "Best-in-class AI scaffolding to prevent hallucinations & omissions",
      body:
        "VitalStrata’s unique LLM safety infrastructure is designed to buoy AI safety metrics and minimize AI pitfalls such as hallucinating false signals and omitting indicators buried in data.",
    },
    {
      title: "Industry-leading performance in coding accuracy",
      body:
        "VitalStrata’s RAF Precision AI boasts industry-leading out-of-the-box coding accuracy and reliability backed by rigorous testing & QA.",
    },
  ];
  return (
    <section
      id="performance-security-safety"
      className={clsx("py-24", className)}
    >
      <Container>
        <div className="text-sm sm:text-sm font-base text-gray-400">PERFORMANCE, SECURITY, SAFETY</div>
        <h2 className="mt-3 font-display text-3xl sm:text-4xl md:text-5xl font-light tracking-tight text-white drop-shadow-lg">
          Built by experts in AI security & LLM workflows for longitudinal data ingestion
        </h2>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-5 gap-12 md:gap-16 items-stretch">
          {/* Left two descriptive blocks */}
          <div className="md:col-span-3 space-y-14">
            {blocks.map((b) => (
              <div key={b.title} className="group cursor-pointer">
                <div className="text-2xl font-light text-white group-hover:text-[#FF8000]">
                  {b.title}
                </div>
                <p className="mt-3 text-base font-light text-white/80 group-hover:text-[#FF8000]">
                  {b.body}
                </p>
              </div>
            ))}
          </div>

          {/* Right: HIPAA badge centered */}
          <div className="flex col-span-2 items-center justify-center">
            <div
              className="transition-transform duration-200 cursor-pointer"
              style={{ transform: hipaaHover ? "scale(1.02)" : "scale(1)" }}
              onMouseEnter={() => setHipaaHover(true)}
              onMouseLeave={() => setHipaaHover(false)}
              aria-label="HIPAA Compliant"
            >
              <HIPAALogo
                className="w-28 h-28 transition-all"
                // Recolor the white SVG via filter on hover to an orange tint
                style={{
                  filter: hipaaHover
                    ? "invert(57%) sepia(93%) saturate(1200%) hue-rotate(0deg) brightness(105%) contrast(102%)"
                    : "none",
                }}
              />
            </div>
          </div>
        </div>
      </Container>
    </section>
  );
};

export default PerformanceSecuritySafety;


